import CampoTexto from '../../components/Formulario/CampoTexto';
import CampoSeletor from '../../components/Formulario/CampoSeletor';
import Grid, { GridItem } from '../../components/layout/Grid';

const tipoOptions = [
  { id: 'receita', label: 'Receita' },
  { id: 'despesa', label: 'Despesa' },
];

export const FormCategoriaFinanceira = ({
  value,
  onChange,
  fieldErrors,
}: {
  value: any;
  onChange: any;
  fieldErrors: any;
}) => {
  return (
    <Grid>
      <GridItem sm={12} md={8}>
        <CampoTexto
          instanceId="nome"
          value={value?.nome ?? ''}
          onChange={v => onChange({ ...value, nome: v })}
          label="Nome"
          error={fieldErrors?.nome}
        />
      </GridItem>
      <GridItem sm={12} md={4}>
        <CampoSeletor
          noSearch
          instanceId="tipo"
          value={value?.tipo ?? 'despesa'}
          onChange={v => onChange({ ...value, tipo: v })}
          label="Tipo"
          options={tipoOptions}
          error={fieldErrors?.tipo}
        />
      </GridItem>
    </Grid>
  );
};
